<template>
  <div class="about">
    <picture>
      <source
        media="(max-width: 767px)"
        srcset="~@/assets/images/about-mobile.png 767w"
      />
      <img class="about-banner" src="~@/assets/images/about.jpg" />
    </picture>
    <Title />
    <AboutPage1 v-if="page === '1'" />
    <AboutPage2 v-if="page === '2'" />
    <AboutPage3 v-if="page === '3'" />
    <AboutPage4 v-if="page === '4'" />
    <AboutPage5 v-if="page === '5'" />
    <AboutPage6 v-if="page === '6'" />
  </div>
</template>

<script>
import Title from 'Pages/MainModule/Title.vue';
import AboutPage1 from 'Pages/AboutModule/AboutPage1.vue';
import AboutPage2 from 'Pages/AboutModule/AboutPage2.vue';
import AboutPage3 from 'Pages/AboutModule/AboutPage3.vue';
import AboutPage4 from 'Pages/AboutModule/AboutPage4.vue';
import AboutPage5 from 'Pages/AboutModule/AboutPage5.vue';
import AboutPage6 from 'Pages/AboutModule/AboutPage6.vue';
export default {
  name: 'About',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  components: {
    Title,
    AboutPage1,
    AboutPage2,
    AboutPage3,
    AboutPage4,
    AboutPage5,
    AboutPage6,
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.about {
  text-align: left;
}
.about-banner {
  width: 100%;
  vertical-align: top;
}
.about > div {
  margin: 20px 20% 0 20%;
}
@media (max-width: 767px) {
  .about-banner {
    margin-top: 10px;
  }
  .about > div {
    margin: 0 20px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .about > div {
    margin: 20px 10% 0 10%;
  }
}
</style>
